import { TrustpilotTestimonialDesktop } from "./TrustpilotTestimonialDesktop";

export { TrustpilotTestimonialDesktop };
